export let BASE_URL: string;

if (process.env.REACT_APP_BACKEND_HOST !== undefined) {
	BASE_URL = process.env.REACT_APP_BACKEND_HOST
}
else {
	BASE_URL = 'http://127.0.0.1:8000/'
}

